import { Grid } from "@mui/material";
import { TextInput } from "components";
import { withForm, WrapperProps } from "hoc";
import { FC } from "react";

import * as yup from "yup";
import { UtilitaireModal } from "../UtilitaireModal";

const schema = yup.object({
  libelle: yup.string().required(),
});

const Form: FC<WrapperProps> = (props) => {
  return (
    <UtilitaireModal
      {...props}
      onClose={props.onBack}
      title="Gestion du centre régional"
    >
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextInput label="Nom *" name="libelle" />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput label="Code" name="code" />
        </Grid>
      </Grid>
    </UtilitaireModal>
  );
};

export const CentreRegionalModal = withForm(Form, schema);
